import { auth } from "../firebase";

export const createUserWithEmailAndPassword = async (
  email: string,
  password: string
): Promise<boolean> => {
  return auth
    .createUserWithEmailAndPassword(email, password)
    .then((userCredential) => {
      // Registrierung erfolgreich
      const user = userCredential.user;
      // Führe hier weitere Aktionen aus, z.B. Weiterleitung zur Hauptseite
      return true;
    })
    .catch((error) => {
      // Fehler bei der Registrierung
      const errorCode = error.code;
      const errorMessage = error.message;
      console.log(errorCode, ": ", errorMessage);
      return false;
    });
};

export const signInWithEmailAndPassword = async (
  email: string,
  password: string
) => {
  return auth
    .signInWithEmailAndPassword(email, password)
    .then((userCredential) => {
      // Anmeldung erfolgreich
      const user = userCredential.user;
      user?.getIdToken().then((token) => {
        localStorage.setItem("token", token);
      });
      return true;
    })
    .catch((error) => {
      // Fehler bei der Anmeldung
      const errorCode = error.code;
      const errorMessage = error.message;
      console.log(errorCode, ": ", errorMessage);
      // Behandle den Fehler hier
      return false;
    });
};

export async function loginWithLocalStorageToken() {
  const token = localStorage.getItem("token");
  if (token) {
    try {
      await auth.signInWithCustomToken(token);
      return true;
    } catch (error) {
      console.error("Error validating token:", error);
      return false;
    }
  } else {
    return false;
  }
}

export const getUid = () => {
  return auth.currentUser?.uid;
};

export const signOut = () => {
  auth.signOut();
};
